/**
 * add-comment-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Comment, Visibility } from "../../../intake-form/comment";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class AddCommentRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_ADD_COMMENT;
	public static tag : MessageTag = MessageTag.REQ_ADD_COMMENT;

  /**
   * Construct a new {@link AddCommentRequest}.
   */
  constructor (
    public comment : string,
    visibility : Visibility,
    selfGroupIds : number[]
  )
  {
    super();
    Comment.applyVisibilityToMessage(this, visibility, selfGroupIds);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/collaboration/add-comment-request.ts